import React from "react";
import { Image, Stack } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./UseAppNotice.scss";
import PrimaryActionButton from "../Buttons/PrimaryActionButton/PrimaryActionButton";
import { openApp } from "../../utils/helpers";
import DownloadAppPrompt, {
  PROMPT_DOWNLOAD_SCENARIOS,
} from "../DownloadAppPrompt/DownloadAppPrompt";
import useDisclosure from "../../hooks/useDisclosure";
import useAuth from "../../hooks/useAuth";
import useGetApp from "../../hooks/useGetApp";
import useAnalytics from "../../hooks/useAnalytics";
import { DownloadAppOptionProperty } from "../../utils/analytics";
import XIcon from "../icons/XIcon";
import { FunctionWithVoidReturn } from "../../utils/constants/generic-types";

export default function UseAppNotice({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: FunctionWithVoidReturn;
}) {
  const { isLoggedIn: userIsLoggedIn } = useAuth();
  const { t } = useTranslation("common");
  const { ctaText, appExists } = useGetApp();
  const analytics = useAnalytics();
  const {
    isOpen: isDownloadAppPromptOpen,
    onOpen: openDownloadAppPrompt,
    onClose: closeDownloadAppPrompt,
  } = useDisclosure();

  const handleCtaClick = () => {
    if (appExists) openApp();
    else openDownloadAppPrompt();
    analytics.sendDownloadAppOptionsEvent(DownloadAppOptionProperty.GET_APP);
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center MobileOnly UseAppNotice">
        <Stack gap={2} direction="horizontal">
          <button onClick={onClose} className="p-0 bg-white">
            <XIcon
              width={20}
              height={20}
              strokeColor="#8C8C8C"
              bgColor="inherit"
            />
          </button>
          <Stack direction="horizontal" gap={2} className="align-items-start">
            <Image
              src="/site-icons/96x96.png"
              alt="Hyper Logo"
              width={30}
              height={30}
            />
            <Stack gap={1} className="align-items-start BannerText">
              <p className="Grotesk AppTitle">
                {t("hyper_play_1v1_games_for_cash")}
              </p>
              <p className="text-start Grotesk AppDescription">
                {t("win_cash_in_games_like_candy_crush_and_many_more")}
              </p>
            </Stack>
          </Stack>
        </Stack>
        <PrimaryActionButton
          size="sm"
          variant="default"
          text={`${t("use_or_get_app", {
            action: ctaText,
          })}`}
          buttonClassName="UseAppCta"
          textClassName="UseAppCtaText"
          onClick={handleCtaClick}
        />
      </div>

      <DownloadAppPrompt
        isOpen={isDownloadAppPromptOpen}
        onOpen={openDownloadAppPrompt}
        onClose={closeDownloadAppPrompt}
        promptDownloadScenario={
          userIsLoggedIn
            ? PROMPT_DOWNLOAD_SCENARIOS.LOGGED_IN.OTHERS
            : PROMPT_DOWNLOAD_SCENARIOS.LOGGED_OUT.OTHERS
        }
      />
    </>
  );
}
